import { PENDING_REDIRECT_KEY } from './pending-redirect.js';

/** Set from the signup URL's ref, read back on every signup event in the tab. */
export const SIGNUP_REF_KEY = 'parcel:signup-ref';

/** Sign-out: a dossier link and its ref belong to this person, never to the next account in the tab. */
export function clearSignupIntent(storage?: Storage): void {
  try {
    const target = storage ?? window.sessionStorage;
    target.removeItem(PENDING_REDIRECT_KEY);
    target.removeItem(SIGNUP_REF_KEY);
  } catch {
    // Sign-out must go through even when storage is blocked.
  }
}
